/* ============================================================================
   JuiceBox Limited VIP 2026 — "Freunde einladen": remember who invited this visitor, and put it on the order.

   Loaded on EVERY page by layout/theme.liquid (the password page renders through it too) while the theme setting
   jb_vip_referral is on and before jb_vip_referral_end_iso (data-end, epoch seconds). Two jobs:

   1. Capture. A link …#ref=CODE or …?ref=CODE (10 hex — the e-mail WP3NYD sends both, the share card on the VIP page
      the fragment, which the browser keeps through the redirect to /password while the shop is locked) is
      remembered on this device: localStorage 'jbVipRef:v1' = {c: CODE, t: ms}. The last link opened wins. The code is
      then removed from the address bar (hash and query, other parameters untouched), so a URL copied from there does
      not pass this inviter's code on. assets/jb-vip.js reads the same key and sends it with a VIP sign-up
      (Klaviyo jb_vip_referred_by / jb_vip_referred_at).

   2. Order. The remembered code goes into the cart as the attribute _jb_ref — POST /cart/update.js with only that key;
      Shopify merges attributes by key and nothing in the theme clears them — so it lands on the order under
      "Additional details" even when the friend never signs up. Once per cart: 'jbVipRefCart:v1' = cart token|code; a new
      cart (after a checkout) gets it again. Not on /password: the cart is locked there, so it is written on the first
      page after the code.

   Counted by the dashboard (JB-EU_vip-lose_v1.0), which also accepts the Checkout Blocks app's own `ref` attribute.
   Nothing here talks to Klaviyo; nothing here can break a page — every step is wrapped and silent.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__jbRefInit) return;
  window.__jbRefInit = true;

  var script = document.currentScript;
  var end = script ? parseInt(script.getAttribute('data-end'), 10) || 0 : 0;
  if (end && Date.now() / 1000 >= end) return;

  var KEY = 'jbVipRef:v1';
  var CART_KEY = 'jbVipRefCart:v1';
  var CODE_RE = /^[0-9A-F]{10}$/;
  var PARAM_RE = /^ref=/i;

  function read(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }
  function write(key, value) { try { localStorage.setItem(key, value); } catch (e) {} }

  function withoutRef(part) {
    return part.split('&').filter(function (p) { return p && !PARAM_RE.test(p); }).join('&');
  }

  /* ---------- 1. capture ---------- */

  var hash = (location.hash || '').replace(/^#/, '');
  var search = (location.search || '').replace(/^\?/, '');
  var found = /(?:^|&)ref=([0-9a-f]{10})(?![0-9a-z])/i.exec(hash + '&' + search);
  if (found) {
    write(KEY, JSON.stringify({ c: found[1].toUpperCase(), t: Date.now() }));
    if (window.history && history.replaceState) {
      try {
        var q = withoutRef(search);
        var h = withoutRef(hash);
        history.replaceState(history.state, '', location.pathname + (q ? '?' + q : '') + (h ? '#' + h : ''));
      } catch (e) {}
    }
  }

  /* ---------- 2. order attribute ---------- */

  var code = '';
  try {
    var stored = JSON.parse(read(KEY) || 'null');
    if (stored && CODE_RE.test(stored.c)) code = stored.c;
  } catch (e) {}
  if (!code) return;
  if (/^\/password/.test(location.pathname)) return; // cart locked until the code is entered

  function cartToken() {
    var m = /(?:^|;\s*)cart=([^;]+)/.exec(document.cookie || '');
    if (!m) return '';
    try { return decodeURIComponent(m[1]).split('?')[0]; } catch (e) { return m[1].split('?')[0]; }
  }

  var token = cartToken();
  if (token && read(CART_KEY) === token + '|' + code) return; // this cart already carries it

  function apply() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      fetch(root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { _jb_ref: code } })
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).then(function (cart) {
        if (cart && cart.token) write(CART_KEY, String(cart.token).split('?')[0] + '|' + code);
      }).catch(function () {});
    } catch (e) {}
  }

  // after the page has settled — never in the way of the first paint or an add-to-cart
  if ('requestIdleCallback' in window) window.requestIdleCallback(apply, { timeout: 3000 });
  else setTimeout(apply, 1200);
})();
